import React, { useEffect, useState} from 'react';
import Image from "../components/common/Image";
import DOMPurify from "dompurify";
import ModalFull from "./ModalFull";



function SliderItem(props) {
  let className = "tw-bg-black tw-rounded-lg tw-overflow-hidden tw-relative";
  if (props.className) className += " " + props.className;

  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const closeVideoModal = () => {
    setVideoModalOpen(!videoModalOpen);
  };
  
  useEffect(() => {
    // Update the document title using the browser API
    if(props.video && typeof props.video !== 'undefined' ) {
      let height = document.getElementsByClassName('swiper-slide')[1].offsetHeight,
          width = document.getElementsByClassName('swiper-slide')[1].offsetWidth;
      
          document.getElementsByClassName('yt-frame')[0].height = height;
          document.getElementsByClassName('yt-frame')[0].width = width;
          document.getElementsByClassName('yt-frame')[0].style= "min-width: "+(width+1)+"px; aspect-ratio: 16/ 9;"
      }
  });

  if(props.video && typeof props.video !== 'undefined' ) {
    let ytIframe = (<iframe 
      className="yt-frame tw-pointer-events-none tw-block tw-h-full tw-w-full"
      src={props.video+"&showinfo=0&controls=0&rel=0&fs=1"}
      loading="lazy" 
      title="Studio Video" 
      frameBorder="0"
      width="374"
      height="190" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>);

    let ytIframeEmb = (<iframe 
      className="yt-frame-embed tw-w-full tw-h-full"
      src={props.video+"&showinfo=0&controls=0&rel=0&fs=1"}
      loading="lazy" 
      title="Studio Video" 
      frameBorder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>)

    return (<div 
      onClick={setVideoModalOpen} 
      className={className+" yt-image"}>
      {ytIframe}
      <ModalFull
        outerClassName="tw-max-h-96"
        isOpen={videoModalOpen}
        show={videoModalOpen === true}
        closeModal={closeVideoModal}
        title="Video"
        scrollable={true}>
        {ytIframeEmb}
      </ModalFull>
      </div>);
  }

  return (
    <div className={className}>
      <Image
        className="tw-h-full tw-w-full tw-object-cover tw-block tw-bg-gray-medium"
        src={props.image}
      />
      {(props.isPresale) && (<p className="tw-absolute tw-bottom-0 tw-w-full tw-py-1 tw-text-xs tw-text-center tw-bg-black tw-text-white tw-uppercase tw-font-condensed">
        {props.presaleText}</p>) }
      {(props.title || props.text) && (
        <div className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-p-5 tw-bg-black/50 tw-text-white tw-backdrop-blur">
          <div
            className="tw-font-condensed tw-font-black tw-text-lg tw-leading-5 tw-uppercase tw-italic tw-pr-8"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(props.title),
            }}
          />
          <div
            className="tw-text-xs tw-pt-2"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.text) }}
          ></div>
        </div>
      )}
    </div>
  );
}

export default SliderItem;
